/* eslint-disable no-param-reassign */
import { ColorFill } from '@tencent/alloy-renderer/dist/fill/color-fill';
import { CharStruct, DrawPlugin, DrawPluginContext } from '../../../../type/common.interface';

export class ColorFillPlugin implements DrawPlugin {
    public before(context: DrawPluginContext<CharStruct>) {
        context.canvasContext.fillStyle = (context.struct.detail?.fill as ColorFill)?.color?.hex || '#000000ff';
    }
    public after(context: DrawPluginContext<CharStruct>): void {
        context.canvasContext.fill('evenodd');
    }
}
